import { DIGITAL_HOME_PHONE } from '@features/Broadband/constants';
import {
  BundleQuoteFragment,
  ProductSubtype,
  ProductType,
} from '@generated/gql/graphql';

const getIsFullFibreSelected = (
  selectedQuotes: BundleQuoteFragment[]
): boolean => {
  const bbQuote = selectedQuotes.find(
    (quote) => quote.product.type === ProductType.Broadband
  );

  return bbQuote?.product.subtype === ProductSubtype.BroadbandFttp;
};

const getIsDigitalHomePhoneSelected = (
  selectedQuotes: BundleQuoteFragment[]
): boolean => {
  const bbQuote = selectedQuotes.find(
    (quote) => quote.product.type === ProductType.Broadband
  );

  return !!bbQuote?.allProductCharges.some(
    ({ name }) => name === DIGITAL_HOME_PHONE
  );
};

const getIsSelectedBroadbandOnly = (
  selectedQuotes: BundleQuoteFragment[]
): boolean => {
  if (!selectedQuotes.length) return false;

  const broadbandQuote = selectedQuotes.find(
    (quote) => quote.product.type === ProductType.Broadband
  );

  if (
    broadbandQuote &&
    broadbandQuote.product.details?.__typename === 'BroadbandProductDetails'
  ) {
    return broadbandQuote.product?.details?.broadbandOnly ?? false;
  }

  return false;
};

export {
  getIsSelectedBroadbandOnly,
  getIsFullFibreSelected,
  getIsDigitalHomePhoneSelected,
};
